module.exports = __webpack_public_path__ + "img/legal-document-templates.1e58e5a0.png";